var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto text-center pt-5",staticStyle:{"width":"100%"}},[_c('h4',[_vm._v("Resource Not Found")])])}]

export { render, staticRenderFns }